import { CoralogixAttributes } from '../constants';
import { resolvePageContext } from '../utils';
import { getSessionManager } from '../helpers';
export class CoralogixNavigationProcessor {
    forceFlush() {
        return Promise.resolve();
    }
    onEnd(span) { }
    onStart(span) {
        const pageContext = resolvePageContext(location.href);
        if (pageContext) {
            span[CoralogixAttributes.PAGE_CONTEXT] = pageContext;
            const { currentPageFragment } = getSessionManager();
            const { page_fragments } = pageContext;
            if (currentPageFragment !== page_fragments) {
                getSessionManager().currentPageFragment = page_fragments;
                span[CoralogixAttributes.IS_NAVIGATION_EVENT] = true;
            }
        }
    }
    shutdown() {
        return Promise.resolve();
    }
}
//# sourceMappingURL=CoralogixNavigationProcessor.js.map